<template>
  <div :class="$style.dropDownWrapper">
    <BDropdown
      :class="$style.dropDownContainer"
      :menuClass="menuClass"
      @hide="handleHide"
      @shown="handleShown"
    >
      <template #button-content>
        <i :class="[$style.dropdownIcon, selectedValueIconClassName]" />
        <span :class="$style.dropdownValue">{{ selectedValueText }}</span>
      </template>
      <div
        v-if="listTitle"
        :class="$style.listTitle"
      >
        {{ listTitle }}
      </div>
      <CustomSelectIconListItem
        v-for="(menuItem, index) in menuItems"
        :key="index + 1"
        :disabled="menuItem.disabled"
        :iconClassName="menuItem.iconClassName"
        :index="index"
        :isDisabled="menuItem.isDisabled"
        :onClick="menuItem.onClick"
        :selected="sudoStatusSelectedText"
        :showHeader="menuItem.showHeader"
        :styledText="menuItem.styledText"
        :text="menuItem.text"
        :type="menuItem.type"
      />
      <div
        v-if="!isGroupType"
        :class="$style.featureInfo"
      >
        Permissions can now be controlled at the group level.
        <a href="/#/groups/user">Check it out</a>
      </div>
    </BDropdown>
  </div>
</template>
<script>
import { ItemTypeConsts } from 'client/util/Constants';
import CustomSelectIconListItem from 'client/components/ItemTable/BodyComponents/CustomSelectIconListItem.vue';
// eslint-disable-next-line import/extensions
import {
  BDropdown,
} from 'bootstrap-vue';

export default {
  name: 'CustomSelectIconList',

  components: {
    BDropdown,
    CustomSelectIconListItem,
  },

  props: {
    itemType: {
      type: String,
      default: undefined,
    },
    listTitle: {
      type: String,
      required: false,
      default: '',
    },
    menuItems: {
      type: Array,
      required: true,
      validator: function validator(menuItems) {
        if (!Array.isArray(menuItems)) {
          return false;
        }

        return menuItems.length > 0;
      },
    },
    selectedValueIconClassName: {
      type: [Array, String],
      required: true,
    },
    selectedValueText: {
      type: String,
      required: true,
    },
    sudoStatusSelectedText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      menuClass: [this.$style.dropdownMenu],
    };
  },

  computed: {
    isGroupType() {
      return this.itemType && this.itemType.includes(ItemTypeConsts.group);
    },
  },

  methods: {
    handleHide() {
      const index = this.menuClass.indexOf(this.$style.dropdownMenuFadeIn);
      this.menuClass.splice(index, 1);
    },

    handleShown() {
      this.$nextTick(() => this.menuClass.push(this.$style.dropdownMenuFadeIn));
    },
  },
};
</script>
<style module>
@import '../../FormValidation/css/formFields.css';

@value (fadeTransition) from '~css/transitions.css';
@value containerSpacing: 8px 16px;

.dropDownContainer button[aria-haspopup="true"] {
  background-color: transparent;
  padding-left: 0;
}

.dropDownContainer button[aria-haspopup="true"]:active:focus {
  box-shadow: none;
  outline: none;
}

.dropdownMenu {
  opacity: 0;
  transition: fadeTransition;
}

.dropdownMenu .dropDownHeader {
  padding: 0 16px;
}

.dropdownMenu:focus {
  outline: none;
}

.dropdownMenuFadeIn {
  opacity: 1;
}

.dropdownValue {
  color: var(--jc-text-color);
  font-size: 0.9rem;
  font-weight: 600;
  margin-right: 8px;
}

.dropDownWrapper .dropdownMenu {
  max-height: none;
  width: 435px;
}

.featureInfo {
  background-color: var(--jcWhite);
  font-size: 0.93rem;
  margin-top: 0.9rem;
  padding: containerSpacing;
}

.featureInfo a {
  font-weight: normal;
}

.listTitle {
  border-bottom: var(--jc-border-width-double) solid var(--jc-border-color);
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.6rem;
  margin-bottom: 7px;
  padding: containerSpacing;
}
</style>
